import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { amenitiesCreationStore } from 'state/listing/amenitiesListing'
import useFormSubmit from 'helper/Hooks/formSubmit'
import AmenitiesForm from './ModalContent/AmenitiesForm'

interface AmenitiesModalProps {
  organizationId?: string
}

const AmenitiesModal: React.FC<AmenitiesModalProps> = ({ organizationId }) => {
  const { form, handleSubmit } = useFormSubmit()
  const { addAmenitiesModal, setAddAmenitiesModal, amenitiesData } =
    amenitiesCreationStore(store => ({
      addAmenitiesModal: store.addAmenitiesModal,
      setAddAmenitiesModal: store.setAddAmenitiesModal,
      amenitiesData: store.amenitiesData,
    }))

  return (
    <>
      <CustomModal
        openModal={addAmenitiesModal}
        closeModal={setAddAmenitiesModal}
        title={amenitiesData ? 'Edit Amenity' : 'Add Amenity'}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText={amenitiesData ? 'Update' : 'Create'}
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <AmenitiesForm form={form} organizationId={organizationId} />
      </CustomModal>
    </>
  )
}

export default AmenitiesModal


